import * as helpers from '../helpers';
import * as mListNavActions from '../actions/mListNavActions';
import NavigationLink from './NavigationLink';
import ProjectTypeList from './ProjectTypeList';
import SuperLink from './SuperLink';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from '../withRouterCompat';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withMapsAndDataProjectsMapLink} from '../utils/mapsAndDataNav';
import {withPartnerWithLadotNavLinks} from '../utils/getInvolvedPartnerForm';


class MListNav extends React.Component{
  componentDidMount(){
    //console.log(`MListNav.componentDidMount()`, this.props);

    if (this.props.cmsName) {
      this.props.actions.initMListNavByCmsName(this.props.cmsName);
    } else if (this.props.cmsId) {
      this.props.actions.initMListNav(this.props.cmsId);
    }
    else if(this.props.mListNav){
      // console.log(`passed in `, this.props.mListNav);
    }
  }


  renderDescription(){
    if(!this.props.mListNav.description) return null;

    return (<div className="m-listnav__description">{helpers.nToP(this.props.mListNav.description)}</div>);
  }
  renderDescriptionOptional(){
    if(!this.props.mListNav.descriptionOptional) return null;

    return (<div className="m-listnav__description m-listnav__description--optional">{helpers.nToP(this.props.mListNav.descriptionOptional)}</div>);
  }
  renderNavigationLinks(){
    if(!this.props.mListNav.navigationLinks) return null;

    const ListTag = this.props.useListMarkup ? 'ul' : 'div';

    return (
      <ListTag className="m-listnav__list">
        {this.props.mListNav.navigationLinks.map(navigationLink => {
          if(navigationLink.title){
            return (
              <NavigationLink asListItem={this.props.useListMarkup}
                              className={['m-listnav__navigationlink', navigationLink.className].filter(Boolean).join(' ')}
                              highlight={this.props.mListNav.highlight}
                              key={`${navigationLink.id || navigationLink.key}-${navigationLink.title || ''}`}
                              navigationLink={navigationLink}
                              onClick={navigationLink.onClick}/>
            );
          }
          else if(navigationLink.id || navigationLink.documentId){
            return (
              <NavigationLink asListItem={this.props.useListMarkup}
                              className={['m-listnav__navigationlink', navigationLink.className].filter(Boolean).join(' ')}
                              cmsId={navigationLink.documentId || navigationLink.id}
                              highlight={this.props.mListNav.highlight}
                              key={navigationLink.id}
                              onClick={navigationLink.onClick}/>
            );
          }

          return (
            <NavigationLink asListItem={this.props.useListMarkup}
                            className={['m-listnav__navigationlink', navigationLink.className].filter(Boolean).join(' ')}
                            highlight={this.props.mListNav.highlight}
                            key={navigationLink.key}
                            navigationLink={navigationLink}
                            onClick={navigationLink.onClick}/>
          );
        })}
      </ListTag>
    );
  }
  renderProjectTypes(){
    if(!this.props.mListNav.projectTypes || this.props.mListNav.projectTypes.length < 1) return null;

    const navListId =
      this.props.cmsId ||
      this.props.mListNav.documentId ||
      this.props.mListNav.id;
    const cmsName = this.props.cmsName || this.props.mListNav.cmsName;
    return (<ProjectTypeList navListId={navListId} cmsName={cmsName}/>);
  }
  renderTitle(){
    if(!this.props.mListNav.title) return null;

    if(this.props.mListNav.url)
      return (<SuperLink to={this.props.mListNav.url} className="m-listnav__title">{this.props.mListNav.title}</SuperLink>);
    else
      return (<div className="m-listnav__title">{this.props.mListNav.title}</div>);
  }
  render(){
    //console.log(`MListNav render`, this.state, this.props);
    if(!this.props.mListNav ||
       (!this.props.mListNav.title && !this.props.mListNav.navigationLinks)) return null;

    let displayModeClass = this.props.mListNav.displayMode ? `m-listnav--${this.props.mListNav.displayMode}` : ``;

    return (
      <div className={`m-listnav ${this.props.className || ''} ${displayModeClass}`}>
        {this.renderTitle()}
        {this.renderProjectTypes()}
        {this.renderDescription()}
        {this.renderDescriptionOptional()}
        {this.renderNavigationLinks()}
      </div>
    );
  }
}


export default withRouter(connect(
  (state, ownProps) => {
    if (ownProps.cmsName) {
      const mListNav = helpers.getByCmsName(state.mListNav, ownProps.cmsName);
      // Keep Projects Map visible even if a header reload raced the list-nav init.
      return {
        mListNav: withPartnerWithLadotNavLinks(
          withMapsAndDataProjectsMapLink(mListNav, ownProps.cmsName),
        ),
      };
    }
    if (ownProps.cmsId) {
      return { mListNav: helpers.getById(state.mListNav, ownProps.cmsId) };
    }
    return {};
  },
  (dispatch) => ({
    actions: bindActionCreators(mListNavActions, dispatch),
  }),
)(MListNav));


MListNav.propTypes = {
  actions: PropTypes.object,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  cmsName: PropTypes.string,
  mListNav: PropTypes.object,
  useListMarkup: PropTypes.bool,
};
